export default __webpack_public_path__ + "media/images/ogp/ot_ogp1-0ff9b8ab49e25ac88aeac0899ec3eaa5.jpg";